import { Component, EventEmitter, Input, Output, TemplateRef } from "@angular/core";

@Component({
	selector: 'pcm-page-container',
	templateUrl: './page-container.component.html',
	styleUrls: ['./page-container.component.scss']
})
export class PageContainerComponent {
	@Input() pageTitle = '';

	@Input() headerContent: TemplateRef<any>;

	@Input() showCompassTour = false;
	@Input() compassTooltipPosition = 'left';
	@Input() compassIconTooltipText = 'Start the tour';
	@Input() centeredHeader = false;

	// true - all contents in this container will be scrollable
	// false - scroll is set to hidden, so the page will have to manage its own scrolling
	@Input() scrollBody = true;

	@Output() compassTourClick: EventEmitter<any> = new EventEmitter();
}
